var React = require('react');

function CaretUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 168a19.41 19.41 0 0 1 13.37 5.29c.27.26.54.53.8.8l128.92 134.26c12.63 13.15 3.68 35.65-14.17 35.65H160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 344H31.08c-17.85 0-26.8-22.48-14.17-35.63l128.92-134.28c.26-.27.53-.54.8-.8A19.41 19.41 0 0 1 160 168z","className":"fa-primary","key":2})]);
}

CaretUp.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = CaretUp;

CaretUp.default = CaretUp;
